import { render, staticRenderFns } from "./FormForMedidor.vue?vue&type=template&id=0ab220cc&"
import script from "./FormForMedidor.vue?vue&type=script&lang=js&"
export * from "./FormForMedidor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports